export default {
  account: {
    Bank: 'Bank',
    CardNo: 'Card No',
    AccountName: 'Account Name',
    Balance: 'Balance',
    AddAccount: 'Add Account',
    EditAccount: 'Edit Account',
    BankNameCanNotBeEmpty: 'Bank Name Can Not Be Empty',
    AccountNameCanNotBeEmpty: 'Account Name Can Not Be Empty',
    CardNoCanNotBeEmpty: 'Card No Can Not Be Empty',
    BalanceCanNotBeEmpty: 'Balance Can Not Be Empty',
    PleaseEnterCorrectCardNo: 'Please Enter Correct Card No',
    PleaseEnterCorrectBalance: 'Please Enter Correct Balance'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/account.js